export const INFORMATION_ICON_TEXT = 'Information icon';
